import { Divider, Notification, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { pricingBinder } from "libs/analytics/binders/onboarding/pricing";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { Title } from "../Title";
import { AccommodationCategoryEnum } from "../constants/accommodationCategoryEnum.ts";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useAccommodationCategory } from "../useAccommodationCategory.ts";
import { PayoutHeader } from "./PayoutHeader";
import { WeeklyMonthly } from "./WeeklyMonthly";
import { First3BookingController } from "./discounts/First3BookingController";
import { PayoutController } from "./payout/PayoutController";
import { PromotionFooter } from "./promotion/PromotionFooter.tsx";

export const PricingPage = () => {
    const {
        cmsData: {
            pricing: { pricing, addStarterPromotion, first3BookingsNotice },
        },
    } = useStaticDataAtomValue();
    const { hasAccommodationTypes } = useAccommodationCategory();
    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(pricingBinder);

    const isHotel = hasAccommodationTypes(AccommodationCategoryEnum.Hotel, AccommodationCategoryEnum.MultipleNha);

    return (
        <VStack gap="24" pb="32">
            <Title title={pricing} />
            <Typography variant="heading-default">{addStarterPromotion}</Typography>
            <Notification
                intent="notice"
                asset={{
                    id: "fill.symbol.lightbulb",
                }}
                title={first3BookingsNotice}
            />
            <First3BookingController />
            {!isHotel && <WeeklyMonthly />}
            <PromotionFooter />
            <Divider />
            <PayoutHeader />
            <PayoutController />
        </VStack>
    );
};
